var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgId(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1638501194561,
    className: "icon",
    viewBox: "0 0 1538 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 4349,
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.309622 1014.415575h1515.968551V6.229876H11.309622v1008.185699z m1523.923624 9.584425v-9.584425 9.584425zM5.079745 1021.891426V0H1533.508049v1020.741295H4.983901v1.150131z",
    fill: "#353636",
    "p-id": 4350
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.817671 3.83377h1522.198428v507.782853H8.817671z",
    fill: "#CC303C",
    "p-id": 4351
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.817671 510.370648h1522.198428v507.782853H8.817671z",
    fill: "#FFFFFF",
    "p-id": 4352
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgId);
export default __webpack_public_path__ + "static/media/id.4840bc1f.svg";
export { ForwardRef as ReactComponent };